import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToasterService } from '../_services/toaster.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  constructor(private toasterService: ToasterService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        let errorMessage = 'An unknown error occurred!';
        
        if (error.error instanceof ErrorEvent) {
          // Client-side error
          errorMessage = `Error: ${error.error.message}`;
        } else {
          // Server-side error
          errorMessage = error.error?.Message || error.message || errorMessage;
          
          if (error.status === 401) {
            errorMessage = 'Unauthorized. Please login again.';
            // Optionally redirect to login
          } else if (error.status === 403) {
            errorMessage = 'You do not have permission to perform this action.';
          } else if (error.status === 404) {
            errorMessage = 'The requested resource was not found.';
          } else if (error.status === 500) {
            errorMessage = 'Internal server error. Please try again later.';
          }
        }

        this.toasterService.Error(errorMessage, 'API Error');
        return throwError(() => new Error(errorMessage));
      })
    );
  }
}
